import React from "react";
import PropTypes from "prop-types";
import { Select } from "rbx";

import { STATES } from "../../utils";

function StateSelect({
  value,
  name,
  onChange,
  size,
  disabled,
  readOnly,
  tabIndex
}) {
  return (
    <Select.Container fullwidth size={size}>
      <Select
        disabled={disabled || readOnly}
        name={name}
        tabIndex={tabIndex}
        value={value}
        onChange={onChange}
      >
        <Select.Option value="">State</Select.Option>
        {Object.keys(STATES)
          .sort()
          .map(key => (
            <Select.Option key={key} value={key}>
              {key}
            </Select.Option>
          ))}
      </Select>
    </Select.Container>
  );
}

StateSelect.propTypes = {
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.string,
  name: PropTypes.string,
  tabIndex: PropTypes.string
};

StateSelect.defaultProps = {
  value: "",
  name: "State"
};
export default StateSelect;
